module.exports = __webpack_public_path__ + "static/img/pig.2f5d8f75.png";